<template>
  <div>
    <div class="mb-4">
      <div class="sm:hidden">
        <select aria-label="Selected tab" class="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5 transition ease-in-out duration-150">
          <option>My Account</option>
          <option>Company</option>
          <option selected>Team Members</option>
          <option>Billing</option>
        </select>
      </div>
      <div class="hidden sm:block">
        <div class="border-b border-gray-200">
          <nav class="-mb-px flex">
            <button v-for="(order, index) in list"
                    class="whitespace-nowrap py-4 px-1 border-b-2 border-transparent font-medium
                    text-sm leading-5  focus:outline-none"
                    :class="{
                      'ml-8': index > 0,
                      'border-indigo-500 text-indigo-600 focus:text-indigo-800 focus:border-indigo-700': current_tab === order.id,
                      'text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300': current_tab !== order.id
                    }"
            >Order #{{ order.id }}</button>

          </nav>
        </div>
      </div>
    </div>

    <div v-if="current_tab !== null && !handoverComplete">

      <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-4">
        <div class="col-span-1">
          <dt class="text-sm leading-5 font-medium text-gray-500">
            Customer
          </dt>
          <dd class="mt-1 text-sm leading-5 text-gray-900">
            {{ selectedOrder.customer_account.name }} (TIN: {{ selectedOrder.customer_account.tin_number }})
          </dd>
        </div>
      </dl>

      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul>
          <li v-for="item in itemsOfOrder(current_tab)">
            <div class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <div class="text-sm leading-5 font-medium text-indigo-600 truncate">
                    {{ item.item_code }} <span class="text-gray-500">- {{ item.description }}</span>
                  </div>
                  <div class="ml-2 flex-shrink-0 flex">
                    <text-input inline label="Quantity" class="w-48" type="number" :errors="errors[`items.${item.id}.quantity`]" min="1" :max="originalItem(item.id).handover_quantity" @change="validateQty(item.id)" v-model="selectedItem(item.id).handover_quantity"></text-input>
                  </div>
                </div>
                <div class="mt-2 sm:flex sm:justify-between">
                  <div class="sm:flex">
                    <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                    </svg>
                    <span>
                    <time datetime="item.handover_date">{{ item.handover_date }}</time>
                  </span>
                  </div>
                  <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">
                    Unit: <span class="ml-2 font-medium text-gray-800">{{ item.unit }}</span>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <div v-if="success" class="mb-8 flex items-center justify-between bg-green-500 rounded max-w-3xl">
        <div class="flex items-center">
          <svg class="ml-4 mr-2 flex-shrink-0 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><polygon points="0 11 2 9 7 14 18 3 20 5 7 18" /></svg>
          <div class="py-4 text-white text-sm font-medium">{{ success }}</div>
        </div>
        <button type="button" class="group mr-2 p-2" @click="success = null">
          <svg class="block w-2 h-2 fill-green-800 group-hover:fill-white" xmlns="http://www.w3.org/2000/svg" width="235.908" height="235.908" viewBox="278.046 126.846 235.908 235.908"><path d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z" /></svg>
        </button>
      </div>

      <div v-if="error" class="mb-8 flex items-center justify-between bg-red-500 rounded max-w-3xl">
        <div class="flex items-center">
          <svg class="ml-4 mr-2 flex-shrink-0 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" /></svg>
          <div class="py-4 text-white text-sm font-medium">{{ error }}</div>
        </div>
        <button type="button" class="group mr-2 p-2" @click="error = null">
          <svg class="block w-2 h-2 fill-red-800 group-hover:fill-white" xmlns="http://www.w3.org/2000/svg" width="235.908" height="235.908" viewBox="278.046 126.846 235.908 235.908"><path d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z" /></svg>
        </button>
      </div>
    </div>

    <div class="mt-4">
      <button class="btn-primary" v-if="showPreviousButton" @click="previousTab">Previous</button>
      <button class="btn-primary" v-if="showNextButton" @click="nextTab">Next</button>
      <div class="inline-block" v-if="showSaveButton && !handoverComplete">
        <loading-button :loading="saving" class="btn-primary inline-block" @click="saveHandover">Handover Items</loading-button>
      </div>
      <button class="btn-primary" v-if="handoverComplete" @click="$emit('close')">Close</button>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash';
  import TextInput from '@/Shared/TextInput'
  import LoadingButton from '@/Shared/LoadingButton'
  export default {
    name: 'HandoverToDeliveryTeamModal',
    components: {LoadingButton, TextInput},
    props: {
      items: Array,
      orders: Array,
      type: String
    },

    data() {
      return {
        saving: false,
        current_tab: null,
        errors: {},
        error: null,
        success: null,
        handoverComplete: false,

        handoverItems: [],
      }
    },

    mounted() {
      this.current_tab = this.list[0].id

      this.items.forEach(itm => {
        this.handoverItems.push(Object.assign({}, itm))
      })
    },

    methods: {
      nextTab() {
        let currentTabIndex = this.list.findIndex(itm => itm.id === this.current_tab)

        if (currentTabIndex <= this.list.length-1) {
          let nextOrder = this.list[currentTabIndex+1]
          this.current_tab = nextOrder.id
        }
      },

      previousTab() {
        let currentTabIndex = this.list.findIndex(itm => itm.id === this.current_tab)
        if (currentTabIndex > 0) {
          let previousOrder = this.list[currentTabIndex-1]
          this.current_tab = previousOrder.id;
        }
      },

      validateQty(item_id) {
        let current = Math.round(this.selectedItem(item_id).handover_quantity);
        let original = this.originalItem(item_id).handover_quantity;

        if (parseFloat(current) > original || current === '') {
          this.selectedItem(item_id).handover_quantity = original
        } else if (parseFloat(current) <= 0) {
          this.selectedItem(item_id).handover_quantity = 1
        } else {
          this.selectedItem(item_id).handover_quantity = current
        }
      },

      saveHandover() {
        this.saving = true;

        let formData = new FormData();
        this.handoverItems.forEach(itm => {
          formData.append(`items[${itm.id}][order_id]`, itm.order_id)
          formData.append(`items[${itm.id}][quantity]`, itm.handover_quantity)
        });

        this.$http.post(this.route('ajax.handover-to-team'), formData).then(response => {
          this.saving = false
          this.success = response.data.message
          this.handoverComplete = true;
        }).catch(error => {
          this.saving = false
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
          } else {
            this.error = error.response.data.message
          }
        })
      },

      resetMessages() {
        this.success = null;
        this.error = null;
        this.errors = {};
      }
    },


    computed: {
      showNextButton() {
        let currentTabIndex = this.list.findIndex(itm => itm.id === this.current_tab)

        return currentTabIndex < this.list.length -1;
      },

      showSaveButton() {
        let currentTabIndex = this.list.findIndex(itm => itm.id === this.current_tab)

        return currentTabIndex === this.list.length -1;
      },

      showPreviousButton() {
        let currentTabIndex = this.list.findIndex(itm => itm.id === this.current_tab)

        return currentTabIndex > 0;
      },

      list () {
        let order_ids = _.uniq(this.items.map(itm => itm.order_id));

        let orders = this.orders.filter(itm => {
          return order_ids.indexOf(itm.id) !== -1;
        })

        return orders;
      },

      originalItem() {
        return id => {
          return this.items.find(itm => itm.id === id)
        }
      },

      selectedItem() {
        return id => {
          return this.handoverItems.find(itm => itm.id === id)
        }
      },

      selectedOrder() {
        return this.list.find(itm => itm.id === this.current_tab)
      },

      itemsOfOrder() {
        return function (order_id) {
          let item_ids = this.handoverItems.map(itm => itm.id);

          let order = this.orders.find(itm => itm.id === order_id)

          return order.items.filter(itm => item_ids.indexOf(itm.id) !== -1)
        }
      }
    }
  }
</script>
